import URI from 'urijs';
window.URI = URI;

if (!window.jQuery) {
  window.jQuery = window.$ = require('jquery');
}

var modaal = require('modaal');
